import { Realm, REALMS } from "../constants";

export const parseRealm = (value: string | null | undefined, fallback: Realm = "NA"): Realm => {
  const candidate = value?.toUpperCase() as Realm;
  return REALMS.includes(candidate) ? candidate : fallback;
};
